(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6670],{

/***/ 46665:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workbench",
      function () {
        return __webpack_require__(58624);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58624:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": () => (/* binding */ __N_SSP),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66436);




antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].config */ .ZP.config({
    maxCount: 1
});
const MobileWorkbench = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(1970), __webpack_require__.e(8937), __webpack_require__.e(7503), __webpack_require__.e(8959), __webpack_require__.e(4751), __webpack_require__.e(9876), __webpack_require__.e(1173), __webpack_require__.e(8028), __webpack_require__.e(7722), __webpack_require__.e(2723), __webpack_require__.e(114), __webpack_require__.e(2151), __webpack_require__.e(1671), __webpack_require__.e(5547)]).then(__webpack_require__.bind(__webpack_require__, 15544)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15544)
            ]
    },
    ssr: false
});
const WebWorkbench = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(4635), __webpack_require__.e(8006), __webpack_require__.e(8319), __webpack_require__.e(6867), __webpack_require__.e(4852), __webpack_require__.e(2071), __webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(4640), __webpack_require__.e(4772), __webpack_require__.e(8959), __webpack_require__.e(4751), __webpack_require__.e(9876), __webpack_require__.e(1173), __webpack_require__.e(6753), __webpack_require__.e(3922), __webpack_require__.e(8028), __webpack_require__.e(7722), __webpack_require__.e(4162), __webpack_require__.e(2723), __webpack_require__.e(114), __webpack_require__.e(2151), __webpack_require__.e(8792), __webpack_require__.e(5154), __webpack_require__.e(5023), __webpack_require__.e(1671), __webpack_require__.e(2264)]).then(__webpack_require__.bind(__webpack_require__, 7062)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7062)
            ]
    },
    ssr: false
});
const Workbench = (props)=>{
    const { isMobile , isPersonal  } = props;
    return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileWorkbench, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WebWorkbench, {
        isPersonal: isPersonal
    });
};
var __N_SSP = true;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Workbench);


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2991,9381,9774,2888,179], () => (__webpack_exec__(46665)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);